import { Component, OnInit, Inject, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { log } from 'console';
import { OspService } from 'src/app/core/master-services/osp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { warningMessage } from 'src/app/constants';
import * as moment from 'moment';
import { getUnique, getUniqueByKey, yearWeekToDate } from 'src/app/constants';
import { DeleteBtnCellRender } from 'src/app/configuration-shifts/breaks-detailview/review-changes/review-container.component/delete-btn-cell-render';
import { DeleteBreaksComponent } from 'src/app/configuration-shifts/breaks-detailview/delete-breaks/delete-breaks.component';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogConfig as MatDialogConfig,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { PartstCountService } from 'src/app/services/parts-count/partsCount.service';
import { successMessage } from 'src/app/constants';
import { PartsInventoryService } from 'src/app/services/parts-inventory/parts-inventory.service';

@Component({
  selector: 'app-edit-parts-group-dialog',
  templateUrl: './edit-parts-group-dialog.component.html',
  styleUrls: ['./edit-parts-group-dialog.component.scss']
})
export class EditPartsGroupDialogComponent implements OnInit {
  addPartsGroupEventEmitter = new EventEmitter();
  editPartsGroupEventEmitter = new EventEmitter();
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  userRole = localStorage.getItem('UserRoles');
  user = localStorage.getItem('workdayId');

  rowData = [];
  @ViewChild('osPartsGrid') osPartsGrid;

  gridOptions = {} as any;
  columnDefs;
  defaultColDef;
  rowSelection;
  context: any;
  editType;
  suppressClickEdit = true;
  errorMessage1: any;
  errorMessageUpdate = false;
  master_id: any;
  master_name: any;
  key_item: any;
  data_item: any;
  business_entity: any;
  new_key_item: any;
  cstatus: any;
  showaddpopup: boolean = false;
  showeditpopup: boolean = false;
  dock: any;
  popupname: any;
  groupName: any;
  countCycle:any;
  dayWeek: any;
  inNextDay: any;
  dataItem: any;
  enableError: boolean = false;
  userForm: UntypedFormGroup;
  shiftNumbers: any[] = [];
  errorMessage: any;
  addOrEditform: UntypedFormGroup = this.formBuilder.group({
    groupName: ['',Validators.required],
    countCycle: ['', Validators.required],
    // partNo :['', Validators.required],
    partNo :[''],
    // kanbanNo:['', Validators.required],
    kanbanNo:[''],

  },
  );
  warningMessage: string;
  itContact: any;
  successMessage: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<EditPartsGroupDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly ospService: OspService,
    private readonly spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private readonly OspService: PartstCountService,
    private readonly OspService1: PartsInventoryService,

  ) { 
    this.columnDefs = [
      
      {
        headerName: '',
        field: 'delete',
        sortable: false,
        unSortIcon: false,
        width: 55,
        cellRendererFramework: DeleteBtnCellRender,
        cellRendererParams: {
          clicked: (field?: any) => {
            this.deleteButton(field)
          },
        },
        cellStyle: { cursor: 'pointer' },
      },
      {
        headerName: 'Part No',
        field: 'part_no',
        width: 245,
        editable: false,
      },
      {
        headerName: 'Kanban',
        field: 'kanban',
        width: 240,
      },
    ];
    this.defaultColDef = {
      editable: false
    };
    // this.rowData = null;
    // this.rowData = data
    this.getGridOptions();
  }
  getGridOptions() {
    this.gridOptions = {} as any;
    this.gridOptions.headerHeight = 38;
    this.gridOptions.rowHeight = 28;
    this.gridOptions.floatingFiltersHeight = 0;
    this.gridOptions.rowBuffer = 20;
    this.gridOptions.suppressMovableColumns = true;
    this.gridOptions.enableCellTextSelection = true;
    this.gridOptions.suppressContextMenu = false;
    this.gridOptions.suppressClipboardPaste = true;
    this.gridOptions.defaultColDef = {
      sortable: true,
      suppressMenu: true,
      filter: false,
      floatingFilter: false,
      wrapText: true,
      autoHeight: true,
      suppressPaste: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      unSortIcon: true,
      icons: {
        sortUnSort: '<img src="../../../assets/images/Rectangle8.svg">',
      },
      filterParams: {
        textCustomComparator(filter, value, filterText) {
          const filterTextLoweCase = filterText.toLowerCase();

          let valueLowerCase = '';
          if (value.params) {
            valueLowerCase = value.value.toString().toLowerCase();
          } else {
            valueLowerCase = value.toString().toLowerCase();
          }
          function contains(target, lookingFor) {
            if (target === null) {
              return false;
            }
            return target.indexOf(lookingFor) >= 0;
          }
          return contains(valueLowerCase, filterTextLoweCase);
        },
        debounceMs: 1000,
        caseSensitive: true,
        suppressAndOrCondition: true,
        inRangeInclusive: true,
      },
    };

    return this.gridOptions;
  }
  get addOrEdit() {
    return this.addOrEditform.controls;
  }
  ngOnInit(): void {
    this.onloadGrid();
    this.addOrEditform.controls.groupName.setValue(this.data.groupName);
    this.addOrEditform.controls.countCycle.setValue(this.data.cycleCount);
   
    this.business_entity = localStorage.getItem('namcvalue');
    
   
    console.log("data---", this.data);

    if (this.data?.mode === 'edit') {
      // if (this.data.data?.dock) {
      //   this.addOrEdit.dock.setValue(
      //     this.data.data.dock
      //   );
      // }
    }
  }
  
  submitted: boolean = false;
  
  addPartsGroupDetails() {
    if (!this.addOrEditform.valid) {
      this.submitted = true;
      return;
    }
    console.log(this.addOrEdit,'addOrEdit')
    console.log(this.addOrEditform,'addOrEditform')
    const addEmittedData = {
      partNo: this.addOrEdit.partNo.value,
      kanbanNo: this.addOrEdit.kanbanNo.value,
      groupName: this.addOrEdit.groupName.value,
      countCycle: this.addOrEdit.groupName.value,
    };
    this.addPartsGroupEventEmitter.emit(addEmittedData);
    // this.dialogeRef.close();
  }
  
  editPartsGroupDetails(mode: string) {
    console.log('Editing parts group details for assignment');
    if(mode === 'add'){
      if (this.addOrEditform.invalid) {
        // Trigger form validation errors and show a message if partNo or kanbanNo is not selected
        this.submitted = true;  // Trigger validation on the form
        // this.warningMessage = 'Please select either Part No and Kanban No before adding'; // Or use a custom error message UI component
        return;
      }
      // Get selected values from the form
      const partNo = this.addOrEditform.get('partNo')?.value;  // The part being assigned
      const kanbanNo = this.addOrEditform.get('kanbanNo')?.value;  // Kanban number for reference
      // Log the selected values for debugging
      console.log('Selected Part No:', partNo);
      console.log('Selected Kanban No:', kanbanNo);
        // Ensure both partNo and kanbanNo are selected before adding
      if (!partNo || !kanbanNo) {
        // Trigger form validation errors and show a message if partNo or kanbanNo is not selected
        this.submitted = true;
        this.warningMessage = 'Please select either Part No and Kanban before adding';
        return;
      }
      // Check if the Part No or Kanban No already exists in the grid (duplicates)
      const isPartNoDuplicate = this.rowData.some((row) => row.part_no === partNo);
      const isKanbanNoDuplicate = this.rowData.some((row) => row.kanban === kanbanNo);
      if (isPartNoDuplicate && isKanbanNoDuplicate) {
        this.warningMessage = `Both Part No ${partNo} and Kanban ${kanbanNo} are already added to the group. Please select a different part and kanban.`;
        return;  // Stop if both are duplicates
      } else if (isPartNoDuplicate) {
        this.warningMessage = `Part No ${partNo} is already added to the group. Please select a different part.`;
        return;  // Stop if Part No is a duplicate
      } else if (isKanbanNoDuplicate) {
        this.warningMessage = `Kanban ${kanbanNo} is already assigned. Please select a different Kanban No.`;
        return;  // Stop if Kanban No is a duplicate
      }
      // Create the emitted data
      const assignEmittedData = {
        partNo: partNo,
        kanbanNo: kanbanNo,
        groupName: this.addOrEditform.get('groupName')?.value,  // The group the part is being assigned to
        countCycle: this.addOrEditform.get('countCycle')?.value,
        dock: this.data.dock,
        id: this.data.id,  // ID of the group
        business_entity: this.namcValue,
      };
      // Log the emitted data for debugging
      console.log('Emitted data:', assignEmittedData);
      // Prepare the row data for the grid
      let resultArray = {
        id: assignEmittedData.id,
        business_entity: assignEmittedData.business_entity,
        dock: assignEmittedData.dock,
        part_no: assignEmittedData.partNo,
        kanban: assignEmittedData.kanbanNo,
        group_id : null,
        groupName: this.addOrEditform.get('groupName')?.value,  // The group the part is being assigned to
        countCycle: this.addOrEditform.get('countCycle')?.value,
      };
      // Add to the row data and update the grid
      if (this.osPartsGrid.gridOptions) {
        this.rowData.push(resultArray);
        this.osPartsGrid.gridOptions.api.setRowData(this.rowData);  // Update grid with the new data
      }
      console.log(this.rowData,'rowdata')
      // Reset the dropdown values only after emitting the data
      this.addOrEditform.get('partNo')?.reset();
      this.addOrEditform.get('kanbanNo')?.reset();
      console.log('Part No and Kanban No have been reset after add');
      // Enable both dropdowns after adding
      this.addOrEditform.controls.partNo.enable();
      this.addOrEditform.controls.kanbanNo.enable();
      // Set success message
      this.successMessage = `Part No ${partNo} and Kanban ${kanbanNo} have been successfully added to the group.`;
    }
    if (mode === 'save'){
      console.log('Saving the assigned parts to group');
      if (this.addOrEditform.invalid) {
        this.submitted = true;
        this.warningMessage = 'Please complete the form before saving';
        return;
      }

      // Prepare data from form fields
      const assignEmittedData = {
        groupName: this.addOrEditform.get('groupName')?.value,
        countCycle: this.addOrEditform.get('countCycle')?.value,
        partNo: this.addOrEditform.get('partNo')?.value,
        kanbanNo: this.addOrEditform.get('kanbanNo')?.value,
        dock: this.data.dock,
        id: this.data.id,
        business_entity: this.namcValue,
      };

      // Prepare the data to be saved
      let editData = [];
      if (this.rowData.some(p => p.group_id === null)) {
        editData = this.rowData.filter(p => p.group_id === null);

        // If there are items with no group_id, map them
        const result = editData.map(item => ({
          item_id: item.part_no,
          kanban: item.kanban
        }));

        editData[0].groupName = assignEmittedData.groupName;
        editData[0].countCycle = assignEmittedData.countCycle;
        editData[0].partsKanbanCombination = result;
      } else {
        // If no items with no group_id, prepare new data
        editData.push({
          groupName: assignEmittedData.groupName,
          countCycle: assignEmittedData.countCycle,
          partsKanbanCombination: [{
            item_id: assignEmittedData.partNo,
            kanban: assignEmittedData.kanbanNo
          }]
        });
      }

      // Emit the data to save
      this.editPartsGroupEventEmitter.emit(editData[0]);
    }

  }
  

  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  };

  errorCallback = (error) => {
    console.error(error);
    this.hideSpinner();
    this.removeMessage();
    this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
  };
  hideSpinner() {
    this.spinner.hide();
  }

  callRespectiveFunction(mode:string) {
    if (this.data?.mode === 'edit') {
      console.log('entered if')
      this.editPartsGroupDetails(mode);
    } else {
      this.addPartsGroupDetails();
    }
  }
  editGroups(mode:string){
    console.log('this.rowdata',this.rowData)
    if (this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }
    this.editPartsGroupDetails(mode);
    console.log('this.rowdata_495',this.rowData)
    this.dialogeRef.close();
  }
 
  onPartNoChange(): void {
    const part_no = this.addOrEditform.controls.partNo?.value;
    console.log(part_no, 'part_no');
    // Disable the kanban dropdown
    this.addOrEditform.controls.kanbanNo.disable();
    if (part_no) {
      // Find the item in qpcPartsList matching the part number
      const item = this.data.qpcPartsList?.find((entry) => entry.item_id === part_no);
      console.log(item, 'item');
      // If an item is found, set the kanban value
      if (item) {
        // Set the kanban value in the form
        this.addOrEditform.controls.kanbanNo.setValue(item.kanban);
      }
    }
  }
  onKanbanChange(): void {
    const kanban = this.addOrEditform.controls.kanbanNo?.value;
    console.log(kanban, 'kanban');
    // Disable the part number dropdown
    this.addOrEditform.controls.partNo.disable();
    if (kanban) {
      // Find the item in qpcPartsList matching the kanban number
      const item = this.data.qpcPartsList?.find((entry) => entry.kanban === kanban);
      console.log(item, 'item');
      // If an item is found, set the partNo value
      if (item) {
        // Set the partNo value in the form
        this.addOrEditform.controls.partNo.setValue(item.item_id);
      }
    }
  }
  // grid data
  onloadGrid() {
    if (this.osPartsGrid) {
      this.osPartsGrid.gridOptions.api.refreshHeader();
    }
    this.removeMessage();
    let selectedPartNo;

    const data = {
      offset: 0,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      part_no: selectedPartNo,
      dock: this.data.dock,
      id:this.data.id
    };
    this.spinner.show();
    this.OspService.getEditGroupInsideGrid(data).subscribe({
      error: this.errorCallback,
      next: (res) => {
        console.log(res, 'res')
        this.spinner.hide();
        const updatedRows = res.body.data;
        if (updatedRows.length > 0) {
          // this.successMessage = successMessage.policyUpdated;
          this.rowData = updatedRows;
          let groupId = this.rowData[0].group_id
          console.log( groupId, 'groupId')

          this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
        } else {
          this.rowData = [];
          this.spinner.hide();
          // this.warningMessage = `${warningMessage.reportsNotUpdated}  ${this.itContact}.`;
        }
      },
    });
    return true;
  }
  //delete Api
  deleteButton(field: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '460px';
    dialogConfig.height = '200px';
    dialogConfig.data = {
      mode: 'Edit Group',
    };
    const data1 = {
      offset: 0,
      limit: 1200,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      id: field?.id,
    };
    const dialogRef = this.dialog.open(DeleteBreaksComponent, dialogConfig)
    dialogRef.afterClosed().subscribe((res) => {
      if (res === 'cancel') {
        return;
      } else if (res === 'save') {
        this.spinner.show();
        this.OspService.deleteParts(data1).subscribe({
          error: this.errorCallback,
          next: (data) => {
            if (data.body.tableDeletedCount >= 1 || data.body.tableDeletedCount === 0) {
              this.onloadGrid();
              this.successMessage = successMessage.deleteRecord;
              // this.spinner.show();
              window.scroll(0, 0);
            } else {
              this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
              this.rowData = [];
              this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
              this.spinner.hide();
            }
          },
        });
      }
    })
  }
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);
    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');  
  }

}

